module.exports = __webpack_public_path__ + "static/img/team_advisor_gieno.8436090d.png";